var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
        'step-label-container',
        {clickable: _vm.clickable}
    ],on:{"click":_vm.clickLabel}},[(_vm.showBadge)?_c('div',{class:[
            'step-label',
            _vm.shouldDisplayAsFinished ? 'step-finished' : 'step-todo'
        ]},[(_vm.showCheckmark)?_c('div',[_c('img',{attrs:{"src":"/img/steps/checkmark.svg","alt":""}})]):_c('div',[_vm._v(" "+_vm._s(_vm.label)+" ")])]):_vm._e(),_c('div',{class:[
            'step-title',
            _vm.shouldDisplayAsFinished && _vm.showBadge
                ? 'step-title-finished'
                : 'step-title-todo'
        ]},[_vm._v(" "+_vm._s(_vm.title)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }